import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M928.8064,512 L742.8224,1024 L1177.1264,1024 L991.1424,512 L928.8064,512 Z M1347.8784,1493.8752 L1223.7184,1151.9872 L696.3584,1151.9872 L572.0704,1493.8752 L451.8784,1450.0992 L839.2064,383.9872 L1080.8704,383.9872 L1468.0704,1450.0992 L1347.8784,1493.8752 Z M1728.0384,-0.0128 L192.0384,-0.0128 C86.1824,-0.0128 0.0384,86.1312 0.0384,191.9872 L0.0384,1727.9872 C0.0384,1833.8432 86.1824,1919.9872 192.0384,1919.9872 L1728.0384,1919.9872 C1833.8944,1919.9872 1920.0384,1833.8432 1920.0384,1727.9872 L1920.0384,191.9872 C1920.0384,86.1312 1833.8944,-0.0128 1728.0384,-0.0128 L1728.0384,-0.0128 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTextBackgroundColorSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconTextBackgroundColorSolid, _Component);

  var _super = _createSuper(IconTextBackgroundColorSolid);

  function IconTextBackgroundColorSolid() {
    _classCallCheck(this, IconTextBackgroundColorSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconTextBackgroundColorSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTextBackgroundColor",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTextBackgroundColorSolid.displayName = "IconTextBackgroundColorSolid";
  return IconTextBackgroundColorSolid;
}(Component);

IconTextBackgroundColorSolid.glyphName = 'text-background-color';
IconTextBackgroundColorSolid.variant = 'Solid';
IconTextBackgroundColorSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTextBackgroundColorSolid;
export { IconTextBackgroundColorSolid };